import React, { ImgHTMLAttributes, useCallback, useEffect, useState } from 'react';

import { ContentPreloader, Icon } from '..';
import { colors } from '../../assets/styles';

interface LazyImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

const LazyImage: React.FC<LazyImageProps> = ({ src, className, ...props }) => {
  const [imgSrc, setSrc] = useState<'' | 'error' | string>('');

  const onLoad = useCallback(() => setSrc(src), [src]);

  const onError = useCallback(() => setSrc('error'), []);

  useEffect(() => {
    const img = new Image();
    if (src) {
      img.src = src;
      img.addEventListener('load', onLoad);
      img.addEventListener('error', onError);
    } else onError();

    return () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);
    };
  }, [src, onLoad, onError]);

  return (
    <div
      className={className}
      style={{ backgroundColor: colors.black }}
    >
      {
        imgSrc === '' ? <ContentPreloader background={colors.black} />
          : imgSrc === 'error' ? (
            <div style={{ padding: 35 }}>
              <Icon.Building color={colors.white} />
            </div>
          )
            : <img
              className={className}
              src={imgSrc}
              alt={src}
              {...props}
            />
      }
    </div>
  );
};

export default LazyImage;
